import { render, staticRenderFns } from "./ViewAdmissionFormFullData.vue?vue&type=template&id=58d7db07&scoped=true"
import script from "./ViewAdmissionFormFullData.vue?vue&type=script&lang=js"
export * from "./ViewAdmissionFormFullData.vue?vue&type=script&lang=js"
import style0 from "./ViewAdmissionFormFullData.vue?vue&type=style&index=0&id=58d7db07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d7db07",
  null
  
)

export default component.exports